module.exports = __webpack_public_path__ + "img/footers-templates.4e41f702.png";